// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-treeselect.treeselect-invalid:not(.vue-treeselect--open) .vue-treeselect__control{border-color:#b94a48!important;background-color:#fdd!important}", ""]);
// Exports
module.exports = exports;
